import { use } from 'react';
import CartContext from '../cart.context';
const useCartDiscount = () => {
    const { discount, discountCodeError, resetDiscountCodeError } = use(CartContext);
    return { discount, discountCodeError, resetDiscountCodeError };
};
export default useCartDiscount;
